// This is appended to the stored cert cookie to make it a little harder
// for an attacker to use. This can be any value, but should look somewhat random.
export const certObfuscation = 'ji=AeYm';
